/**
 * Param keys `RequestASessionService` handles: what the directory puts on the provider landing page,
 * plus what the service writes onto the one-page-checkout route when the visitor lands in that arm.
 * Quick checkout receives the same values as typed modal config, so the checkout page is the only
 * consumer that reads them back by key. Shared so producer and consumer resolve to a single source
 * of truth per magic-strings rule.
 */
export enum LandingPageHeaderParam {
  ANON_USER_ID = 'anonUserId',
  NAME = 'name',
  PAYMENT_PREF = 'paymentPref',
  PAYMENT_TAG = 'paymentTag',
  PNC_ID = 'pncId',
  SHARE_CODE = 'share_code',
  /** Abbreviation on the one-page-checkout route; the directory sends the landing page a label. */
  STATE = 'state',
  REFERRING_URL = 'referringUrl',
  SLOT_START_TIME = 'slotStartTime',
  SLOT_END_TIME = 'slotEndTime',
  SESSION_TYPE = 'sessionType'
}
